import {BaseContainerModel} from '../base-container.model';
import {app_file_item_RowClass} from "../../dbschema/app_file_item.model";

export class AppFileItemContainerModel extends BaseContainerModel {
  app_file_item: app_file_item_RowClass = new app_file_item_RowClass();
}
